
import request from '@/utils/request';
import Vue from 'vue';
//创建资料 
export function visaApplicantInformationCreate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantInformation/create`,
      data:params
    });
  }
//查询列表
export function visaApplicantInformationQuery (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantInformation/query`,
      data:params
    });
  }
//详情
export function visaApplicantInformationGetDetail (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantInformation/getDetail/${params}`
    });
  }
// 修改
export function visaApplicantInformationUpdate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantInformation/update`,
      data:params
    });
  }
// 删除 
export function visaApplicantInformationDelete (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantInformation/delete/${params}`
    });
  }
  // 
  export function getInformationType () {
    return request({
      method: 'get',
      url: `${Vue.prototype.$conf.visaService}/visaApplicantInformation/getInformationType`
    });
  }
//所有资料 
export function getAllInformation () {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/visaApplicantInformation/getAllInformation`
  });
}
